import { ReactComponent as LeftSvg } from '../../../images/manifold/left.paths.svg';

type Props = {
  xTransform: number;
  yTransform: number;
};

export const LeftPaths = ({ xTransform, yTransform }: Props) => {
  return (
    <g transform={`matrix(0, -1, 1, 0, ${xTransform}, ${yTransform})`}>
      <LeftSvg />
    </g>
  );
};
